import React, { useEffect } from "react";
import Header from "../Header";
import SuccessResponse from "../reusableComponents/components/generics/SuccessResponse";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { PORTAL } from "../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicyHolderInfo } from "../action";

function SuccessPolicyholder({ requestNo }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClick = () => {
    navigate(PORTAL);
  };
  const { id } = useParams();

  const userData = useSelector((state) => state.profileReducer);
  useEffect(() => {
    dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
  }, [userData?.currentUserResponseData]);

  const splittedid = id.split("=")[1];
  return (
    <div>
      <Header policyholderPage>
        <SuccessResponse
          title={`${t("policyholderSucccesTitle")}${splittedid}`}
          message={t("policyholderSucccesMsg")}
          handleClick={handleClick}
          ButtonName={t("policyholderSucccesBtn")}
        />
      </Header>
    </div>
  );
}

export default SuccessPolicyholder;
